import { useLocation } from 'react-router-dom';
import MainContainer from 'modules/common/MainContainer';
import VpayView from 'modules/vpay/views';

const PharmacyVpayPage = () => {
  const { pathname } = useLocation();
  return (
    <MainContainer context={pathname.startsWith('/vpay/settings') ? 'VPay Settings' : 'VPay'}>
      <VpayView />
    </MainContainer>
  );
};

export default PharmacyVpayPage;
